import { AbstractControl, NgControl } from '@angular/forms';
import { Directive, ElementRef, HostListener, OnInit } from '@angular/core';

// funcations-helper
import matchNumberOnly from 'src/app/core/funcations-helper/text-and-numbers/number-only';
import convertToAmount from 'src/app/core/funcations-helper/text-and-numbers/convert-to-amount';

@Directive({
  selector: '[convertToAmount]'
})
export class ConvertToAmountDirective implements OnInit {

  abstractControl: AbstractControl | null

  @HostListener('input') checkText () {
    this.run()
  }

  constructor(
    private control: NgControl,
    private el: ElementRef<any>
  ) {}

  ngOnInit(): void {
    
    this.el.nativeElement.setAttribute('dir', 'auto')

    if (this.control) {
      this.abstractControl = this.control.control;
      this.run()
    }
  }

  run() {
    let strOfNum = (this.abstractControl?.value?.toString() || '')?.match(/[\d,?]+\.?(\d{1,2})?/) || [];
    this.abstractControl?.patchValue(convertToAmount(strOfNum[0] || ''))

  }

}
